import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

import './App.scss';
import AppView from './views/AppView';
import PrivacyPolicyView from './views/PrivacyPolicyView';
import TermsView from './views/TermsView';
function App() {
  useEffect(() => {});
  return (
    <Router>
      <Switch>
        <Route path="/privacy-policy">
          <PrivacyPolicyView />
        </Route>
        <Route path="/terms-conditions">
          <TermsView />
        </Route>
        <Route path="/">
          <MetaTags>
            <meta
              name="description"
              content="Relax with uQuest and blast your enemies with climate, pollution, viral and nuclear attacks while raising awareness for real issues. Visit us to sign up for early access today!"
            />
            <meta property="og:title" content="uQuest" />
            <meta property="og:image" content="./assets/meta.jpg" />
          </MetaTags>
          <AppView />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
